<template>
	<div class="container-fluid">
		<div class="m-2">
			<div class="alert alert-primary text-center">
				<div class="h4">
					<linkto :link="'/'"/>
					Listák
				</div>
			</div>
		</div>
		<div class="m-2 row d-flex">
			<button
				class="btn btn-primary m-1"
				@click.prevent="download('sendVoiceMail')"
			>
				Hangüzenet-küldési lista
			</button>
		</div>
	</div>
</template>

<script type="text/javascript">
export default {
	methods: {
		async download(type){
			this.$Progress.start()
			this.isLoading = true
			this.req.get('/lists/download/'+type, {}, { responseType: 'blob'} )
				.then(res => {
					const url = window.URL.createObjectURL(new Blob([res.data]))
				   	const link = document.createElement('a')
				   	link.href = url
				   	link.setAttribute('download', `${type}.csv`)
				   	document.body.appendChild(link)
				   	link.click()
				  	this.$Progress.finish()
				  	this.isLoading = false
				})
				.catch(err => {
					console.log(err)
					toastr.error(err.response.data.text || 'hiba a letöltésben')
					this.$Progress.fail()
					this.isLoading = false
				})
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/lists/lists.vue